import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { EncounterAddendum, EncounterSummaryControllerApi } from "@/services";
import { getConfigObject } from "@/utils/utils";

export const ADDENDUM_QUERY_KEY = "encounter-addendum";

interface Props {
  appointmentUuid?: string;
  xTENANTID?: string;
}

/** Signed addendum of a visit; resolves to undefined when the visit has none. */
export const useGetAddendum = ({
  appointmentUuid,
  xTENANTID,
}: Props): UseQueryResult<Partial<EncounterAddendum> | undefined, AxiosError> =>
  useQuery({
    queryKey: [ADDENDUM_QUERY_KEY, appointmentUuid, xTENANTID],
    refetchOnWindowFocus: false,
    enabled: !!appointmentUuid,
    queryFn: async () =>
      new EncounterSummaryControllerApi(getConfigObject())
        .getAddendum(appointmentUuid!, xTENANTID)
        .then(
          (res) =>
            (res.data?.data as Partial<EncounterAddendum> | null) ?? undefined
        ),
  });
